import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { DokumentStavka } from './dokument-stavka';
import { Component } from "@angular/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'yt-dokument-stavka-modal-update',
    templateUrl: './dokument-stavka-modal-update.component.html'
})
export class DokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<DokumentStavka>{
    constructor(
        protected modalContainerService: ModalContainerService<DokumentStavka>,
        protected activeModal: NgbActiveModal,
        protected modalService: ModalService
    
      ) { 
        super(modalContainerService, activeModal,modalService);
      }
    
}